import { createContext } from "react";

const ApproveParentTransactionScreen = createContext<any>(null);

export default ApproveParentTransactionScreen;
